import http from '@/plugins/http'

export default class Company {
  static async create(params) {
    return await http.post('/companies', params)
  }

  static async update(company, params) {
    return await http.put(`companies/${company.id}`, {
      company_id: company.id,
      ...params,
    })
  }

  static async all() {
    return await http.get('companies')
  }

  static async sendDeleteVerificationEmail(company) {
    return await http.get(`companies/${company.id}/send-delete-verification`)
  }

  static async delete(url) {
    return await http.delete(url)
  }

  static async addDomainName(company_id, domain_name) {
    return await http.post(`company-domains`, { company_id, domain_name })
  }
}
